import * as $ from "jquery";
import * as rebindTab from "./rebindTab";
import * as SearchHistory from "./searchHistory";

export function initialize(): void {
    bindFilter();
}

export function bindFilter($context?: JQuery): void {
    ($context ? $context.find(".js-searchfilter") : $(".js-searchfilter")).on(
        "change",
        handleClick
    );

    ($context ? $context.find(".js-filter--box") : $(".js-filter--box")).on(
        "click",
        handleClick
    );

    ($context ? $context.find(".toggleExcludeExpired") : $(".toggleExcludeExpired")).on(
        "change", function () {
        const $input = $("input[name='excludeExpired']");
            $input.val($input.val() === "true" ? "false" : "true");

        const $form = $(this).closest("form");

        $.post($form.data("partialurl"), $form.serialize(), (response) => {
            
            const $response = $(`<div>${response}</div>`);
            const pageTabId = $form.find("input[name='tab']").val();
            const $pageTab = $("#tab-" + pageTabId);
            const $responseTab = $response.find("#tab-" + pageTabId);
            $responseTab
                .find(".content-navigation__link--has-children")
                .prop("ariaPressed", false);

            const $activeTabLink = $(".tabs__link--active:first");
            const $responseTabText = $response.find(".tabs__link--active:first").html();
            $activeTabLink.html($responseTabText);

            const $searchHitsCountText = $response.find(".tabs__link--active:first span").text();
            $('.searchHits .hits').text($searchHitsCountText);
            $('#mobile-toolbar__open span').text($searchHitsCountText);

            rebindTab.rebind($responseTab);
            $pageTab.replaceWith($responseTab);
            SearchHistory.update();

            const currentUrl = new URL(window.location.href);
            document.querySelectorAll<HTMLAnchorElement>(".pagination-container__pages a")
                .forEach(link => {
                    const linkUrl = new URL(link.href);
                    currentUrl.searchParams.forEach((value, key) => {
                        if (key !== "page") {
                            linkUrl.searchParams.set(key, value);
                        }
                    });
                    link.href = linkUrl.toString();
                });
        });

        
    });
}

$(".js-filter--box").keyup(function (event) {
    const $element = $(this);
    if (event.key === "Enter") {
        $element.click();
    }
});

function handleClick(event): void {
  event.preventDefault();
  const $element = $(this);
  const $form = $element.closest("form");

  //Remove selected filter
  if (event.type === "click") {
    let filterValue = "";
    event.currentTarget.innerText.split(" ").forEach((el, i) => {
      if (el[0] !== "(") {
        if (i === 0) {
          filterValue = el;
        } else {
          filterValue = filterValue + ` ${el}`;
        }
      }
    });

    const inputs = $form.find("[value='" + filterValue + "']");
    inputs.prop("checked", false);
    $form
      .find(".content-navigation__link--has-children")
      .prop("aria-pressed", false);
  }

    if ($element.hasClass("search-results_clear-filters")) {
        $('#mobile-toolbar__open').removeClass('button-fullwidth');
    }

  //Get result
  $.post($form.data("partialurl"), $form.serialize(), (response) => {
      response;

      const $response = $(`<div>${response}</div>`);
      const pageTabId = $form.find("input[name='tab']").val();
      const excludeExpired = $("input[name='excludeExpired']").val();
      const $pageTab = $("#tab-" + pageTabId);

      const $responseTab = $response.find(".js-tabcontent-main:first");

      if (event.type === "click") {
          $responseTab
              .find(".content-navigation__link--has-children")
              .prop("ariaPressed", false);
      }
      const $activeTabLink = $(".tabs__link--active:first");
      const $responseTabText = $response.find(".tabs__link--active:first").html();
      $activeTabLink.html($responseTabText);

      const $searchHitsText = $response.find(".tabs__link--active:first span").text();
      $('#searchHits').text($searchHitsText);
      $('#mobile-toolbar__open span').text($searchHitsText);

      $('#mobile-toolbar__open').toggleClass('button-fullwidth', $searchHitsText === '0');
      

      //Re-open the dropdown where the change was made
      /* if (event.type === "change") {
        const $filter = $element.closest(".filters-dropdown__container");
        if($filter) {
            const filterName = $filter.first().find(".content-navigation__link--has-children").data('filter-name');
            if(filterName){
                $responseTab.find("[data-filter-name='" +filterName +"']").prop("ariaPressed", true);
            } 
        }
      } */

    rebindTab.rebind($responseTab);
    $pageTab.replaceWith($responseTab);
    SearchHistory.update();

    const currentUrl = new URL(window.location.href);
    document.querySelectorAll<HTMLAnchorElement>(".pagination-container__pages a")
    .forEach(link => {
        const linkUrl = new URL(link.href);
        currentUrl.searchParams.forEach((value, key) => {
            if (key !== "page") {
                linkUrl.searchParams.set(key, value);
            }
        });
        link.href = linkUrl.toString();
    });

  });
}
